export default __webpack_public_path__ + "static/media/Bengali_fin_m.a48a1276.wav";